import React, { FC } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import FontAwesomeIcon from '../../../../common/font-awesome-icon/font-awesome-icon';
import ROUTES from '../../../../constants/routes';
import translation from '../../../../languages';
import { AI_TABS_ITEMS } from '../../constants/constants';
import './ai-tools-navbar.scss';

const AiToolsNavbar: FC<TranslationProps> = ({ t }) => {
    return (
        <nav className='ai-navbar-wrap'>
            {/*<Link to={ROUTES.AI_TOOLS.path}>*/}
            {/*    <span className='ai-navbar-logo d-flex align-items-center'>*/}
            {/*        <span className='logo-text tsc-h3'>{t('aiTools.navigation.logo')}</span>*/}
            {/*        <span>*/}
            {/*            <FontAwesomeIcon height={28} name='ai-stars-header' width={28} />*/}
            {/*        </span>*/}
            {/*        <span className='ai-navbar-beta'>beta</span>*/}
            {/*    </span>*/}
            {/*</Link>*/}
            <div className='ai-navbar-list'>
                {AI_TABS_ITEMS.map((item) => {
                    return (
                        <NavLink exact className='ai-navbar-item' to={item.path}>
                            <span className='item-title'>{t(`aiTools.navigation.${item.title}`)}</span>
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};

const translate = translation('ai-tools');

export default withRouter(translate(AiToolsNavbar));
